import React from 'react';
import { AnalysisPageWrapper, StyledNav, StyledLinkContainer, AnalysisPageTitle, StyledNavItem, TopButton, SubmitButton, TopBar, AnalysisSubTitle, AnalysisTopButtons, Logo } from './AnalysisPage.styled';
import { Outlet, useLocation } from 'react-router-dom';
import { ReactComponent as LeftArrow } from '../../assets/arrow-left-circle.svg';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';


function AnalysisPage () {
   const location = useLocation();
   const navigate = useNavigate();

   return (
      <>
      <Header page='analysis'/>
      <AnalysisPageWrapper>
         <TopBar>
            <TopButton
               onClick={() => navigate('/input')}
            >
               <LeftArrow />
               Adjust Inputs
            </TopButton>
         </TopBar>
         <TopBar>
         <AnalysisPageTitle>Analysis</AnalysisPageTitle>
         </TopBar>
         <AnalysisSubTitle>Click "Recalculate" to reflect changes across all pages.</AnalysisSubTitle>
         <StyledNav 
            variant="underline"
            defaultActiveKey={"ROI"}
            >
               <StyledLinkContainer to="costs" isActive = {location.pathname === "/analysis/costs"}>
                  <StyledNavItem eventKey={"Costs"}>Costs</StyledNavItem>
               </StyledLinkContainer>
               <StyledLinkContainer to="incentives" isActive = {location.pathname === "/analysis/incentives"}>
                  <StyledNavItem eventKey={"Incentives"}>Incentives</StyledNavItem>
               </StyledLinkContainer>
               <StyledLinkContainer to="roi" isActive = {location.pathname === "/analysis/roi"}>
                  <StyledNavItem eventKey={"ROI"} active>ROI</StyledNavItem>
               </StyledLinkContainer>
               <StyledLinkContainer to="faqs" isActive = {location.pathname === "/analysis/faqs"}>
                  <StyledNavItem eventKey={"FAQs"}>FAQs</StyledNavItem>
               </StyledLinkContainer>
         </StyledNav>
         <Outlet />
         <Footer />
      </AnalysisPageWrapper>
      </>
   )
};

AnalysisPage.propTypes = {};

export default AnalysisPage;
